import { errorHandlerActionTypes } from './constants';

import type { ClearErrorAction, CustomNotification, ErrorType, HandleErrorAction } from './types';

export function handleError(
	error: unknown,
	typeError: ErrorType = 'page-blocking',
	customNotification: CustomNotification | null = null,
): HandleErrorAction {
	console.error('[Error Handler]', error, typeError);

	return {
		type: errorHandlerActionTypes.HANDLE_ERROR,
		payload: {
			error,
			typeError,
			customNotification,
		},
	};
}

export function clearError(): ClearErrorAction {
	return {
		type: errorHandlerActionTypes.CLEAR_ERROR,
	};
}
